import { render, staticRenderFns } from "./AiFeaturesTab.vue?vue&type=template&id=7a1b846a"
import script from "./AiFeaturesTab.vue?vue&type=script&lang=js"
export * from "./AiFeaturesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports